import { UseQuery } from "@reduxjs/toolkit/dist/query/react/buildHooks";

import { QueryDefinition } from "@reduxjs/toolkit/query";

type QDef<QueryArg, ResultType> = QueryDefinition<
  QueryArg,
  any,
  string,
  ResultType,
  string
>;

type useCatalogProductsProps<QueryArg, ResultType> = {
  useQuery: UseQuery<QDef<QueryArg, ResultType[]>>;
  params: QueryArg;
  limit?: number;
  options?: any;
};

export default function useCatalogProducts<QueryArg, ResultType>({
  useQuery,
  params,
  options
}: useCatalogProductsProps<QueryArg, ResultType>) {
  return useQuery(params, options);
}
